import { v4 as uuidv4 } from "uuid";
import { AiOutlineLogout } from "react-icons/ai";
import { FaMapLocationDot } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { MdSubscriptions } from "react-icons/md";
import { MdDashboard } from "react-icons/md";
import { RiCoupon2Fill } from "react-icons/ri";
import { PiMoneyWavyFill } from "react-icons/pi";
import { IoMdSettings } from "react-icons/io";
import { HiDeviceTablet } from "react-icons/hi";
import { MdNotificationsActive } from "react-icons/md";
import { FaMoneyBillTrendUp } from "react-icons/fa6";

const Menuitems = [
  {
    id: uuidv4(),
    title: "Dashboard",
    icon: MdDashboard,
    href: "/dashboard",
    key: "Devices",
  },
  {
    id: uuidv4(),
    title: "Devices",
    icon: HiDeviceTablet,
    href: "/devices",
    key: "Devices",
  },
  {
    id: uuidv4(),
    title: "Location",
    icon: FaMapLocationDot,
    href: "/location",
    key: "Devices",
  },
  {
    id: uuidv4(),
    title: "User management",
    icon: FaUser,
    href: "/user_management",
    key: "Devices",
  },
  {
    id: uuidv4(),
    title: "Subscription ",
    icon: MdSubscriptions,
    href: "/subscription",
    key: "Devices",
  },
  {
    id: uuidv4(),
    title: "Coupons",
    icon: RiCoupon2Fill,
    href: "/coupons",
    key: "Devices",
  },
  {
    id: uuidv4(),
    title: "Recycle Bin",
    icon: PiMoneyWavyFill,
    href: "/recycleBin",
    key: "Devices",
  },
  {
    id: uuidv4(),
    title: "Notifications",
    icon: MdNotificationsActive,
    href: "/notifications",
    key: "Devices",
  },
  {
    id: uuidv4(),
    title: "Revenue",
    icon: FaMoneyBillTrendUp,
    href: "/revenue",
    key: "Devices",
  },

  {
    id: uuidv4(),
    title: "Settings",
    icon: IoMdSettings,
    href: "/settings",
    key: "Devices",
  },

  {
    id: uuidv4(),
    title: "Logout",
    icon: AiOutlineLogout,
    href: "/auth/signin",
  },
];

export default Menuitems;
